import type { DynamicImageDimensions } from './dynamic-image';

/** Horizontal product card media (`w-28` × `h-40`). */
export const PRODUCT_CARD_HORIZONTAL_WIDTH = 112;
export const PRODUCT_CARD_HORIZONTAL_HEIGHT = 160;

export const PRODUCT_CARD_HORIZONTAL_WIDTHS: DynamicImageDimensions = { base: PRODUCT_CARD_HORIZONTAL_WIDTH };
export const PRODUCT_CARD_HORIZONTAL_HEIGHTS: DynamicImageDimensions = { base: PRODUCT_CARD_HORIZONTAL_HEIGHT };

/** Vertical carousel tiles: 318px until `lg`, then 355px. */
export const PRODUCT_CARD_VERTICAL_CAROUSEL_WIDTHS: DynamicImageDimensions = { base: 318, lg: 355 };
export const PRODUCT_CARD_VERTICAL_CAROUSEL_HEIGHTS: DynamicImageDimensions = { base: 318, lg: 355 };

/** Grouped carousel slides stay at 318px. */
export const PRODUCT_CARD_GROUPED_CAROUSEL_WIDTHS: DynamicImageDimensions = { base: 318 };
export const PRODUCT_CARD_GROUPED_CAROUSEL_HEIGHTS: DynamicImageDimensions = { base: 318 };

/** Cross-sell carousel slides stay at 355px. */
export const PRODUCT_CARD_CROSS_SELL_WIDTHS: DynamicImageDimensions = { base: 355 };
export const PRODUCT_CARD_CROSS_SELL_HEIGHTS: DynamicImageDimensions = { base: 355 };

export const WISHLIST_AVATAR_SIZE = 64;
export const WISHLIST_AVATAR_WIDTHS: DynamicImageDimensions = { base: WISHLIST_AVATAR_SIZE };
export const WISHLIST_AVATAR_HEIGHTS: DynamicImageDimensions = { base: WISHLIST_AVATAR_SIZE };

/** Vertical PLP: 1 column → 2 at `md` → 3 at `lg`. */
export const PRODUCT_GRID_VERTICAL_WIDTHS_WITH_REFINEMENTS: DynamicImageDimensions = {
    base: '88vw',
    md: '45vw',
    lg: '28vw',
    xl: '26vw',
    '2xl': '24vw',
};
export const PRODUCT_GRID_VERTICAL_WIDTHS_WITHOUT_REFINEMENTS: DynamicImageDimensions = {
    base: '88vw',
    md: '45vw',
    lg: '32vw',
    xl: '30vw',
    '2xl': '28vw',
};

/** Event/course tiles: 2 columns from base, 4 at `lg+`. */
export const PRODUCT_GRID_EVENT_WIDTHS_WITH_REFINEMENTS: DynamicImageDimensions = {
    base: '45vw',
    lg: '22vw',
    '2xl': '24vw',
};
export const PRODUCT_GRID_EVENT_WIDTHS_WITHOUT_REFINEMENTS: DynamicImageDimensions = {
    base: '45vw',
    lg: '24vw',
    '2xl': '25vw',
};
